import {
  apiClient,
} from './apiClient';

import type {
  ProvincesListData,
} from '../types/provinces.types';

export const provincesApi = {
  list() {
    return apiClient.get<ProvincesListData>(
      '/provinces',
    );
  },
};